import React, { useMemo } from 'react'
import { Box, Typography } from '@mui/material'
import { AccessAlarm } from '@mui/icons-material'
import { useAppSelector } from '../hooks/redux'
import { useGetTeamsQuery } from '../store/api/teamsApi'
import { useGetCasesQuery } from '../store/api/casesApi'
import { useGetMemorialDeadlineStatusQuery } from '../store/api/memorialsApi'
import SubmissionDeadlineCountdown from './SubmissionDeadlineCountdown'

export default function GlobalDeadlineBanner() {
  const { user, isAuthenticated } = useAppSelector((state) => state.auth)

  // Chỉ hiển thị banner cho sinh viên (thí sinh)
  const isStudent = user?.role === 'student'
  
  const { data: teams = [] } = useGetTeamsQuery(undefined, { skip: !isStudent || !isAuthenticated })
  const { data: cases = [] } = useGetCasesQuery(undefined, { skip: !isStudent || !isAuthenticated })

  const userTeam = useMemo(() => {
    if (!isStudent) return null
    return teams.find((t) => t.members.includes(user?.id || '')) || null
  }, [teams, user, isStudent])

  const activeCase = useMemo(() => {
    if (!userTeam) return null
    return cases.find((c) => c.assigned_team_ids?.includes(userTeam.id)) || null
  }, [cases, userTeam])

  // Lấy deadline cho case hiện tại của sinh viên
  const { data: deadlineStatus } = useGetMemorialDeadlineStatusQuery(activeCase?.id || '', {
    skip: !activeCase?.id,
    pollingInterval: activeCase?.id ? 1000 : undefined, // Poll to keep countdown fresh
  })

  if (!isStudent || !activeCase || !deadlineStatus) return null
  
  // Không hiện banner nếu cửa sổ nộp bài chưa mở hoặc không có ngày đóng cửa sổ
  if (!deadlineStatus.round_closes_at) return null

  // Tuỳ chỉnh màu sắc dựa vào việc còn hạn hay không
  const isOpen = deadlineStatus.submission_open
  const bgColor = isOpen ? 'warning.light' : 'error.light'
  const textColor = isOpen ? 'warning.contrastText' : 'error.contrastText'

  return (
    <Box
      sx={{
        backgroundColor: bgColor,
        color: textColor,
        px: 2,
        py: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        flexWrap: 'wrap',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        zIndex: 1100, // Đảm bảo nổi trên các elements khác
      }}
    >
      <AccessAlarm fontSize="small" />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Typography variant="body2" fontWeight={600}>
          {deadlineStatus.message}
        </Typography>
        <Box sx={{ fontWeight: 'bold', '& > div': { display: 'inline', ml: 1 } }}>
          <SubmissionDeadlineCountdown status={deadlineStatus} />
        </Box>
      </Box>
    </Box>
  )
}
